import React, {Fragment, Component} from 'react'
import { connect } from 'react-redux'
import moment from 'moment/moment'

import BkFlowRoomCardNightlyRates from '../BkFlowRoomCardNightlyRates'
import BkFlowPartnersBenefitsBanner from '../../../partners/BkFlowPartnersBenefitsBanner'
import BkFlowRoomCardTaxesFees from '../BkFlowRoomCardTaxesFees'

import _ from 'lodash'
import yn from 'yn'

import getCurrencySymbol from '../../../../utilities/currency/getCurrencySymbol'
import formatPrice from '../../../../utilities/currency/formatPrice'
import dateFormats from '../../../../utilities/dates/dateFormats'

import informationIcon from '../../../../assets/icons/information-icon.svg'
import arrowRightLong from '../../../../assets/icons/arrow-right-long.svg'

class BkFlowRoomCardCondensedPriceButton extends Component {
	render() {
		const {
			activeCurrencyData,
			activeStep,
			availabilityData,
			configData,
			displayedPriceFrequency,
			enhancementData,
			multiRoomData,
			ratePlanData,
			roomGroup,
			roomRateData,
			toggleActiveRoom,
			totalNights,
			urlData,
		} = this.props

		const addTotals = (a, b) => a + b
		const hotelLabels = configData.hotel.labels[0]

		let roomRateDiscountData = [],
				roomRatePrice = null,
				rateBeforeDiscount = null,
				rateCancelCurrencyCode = null,
				rateCancelCurrencySymbol = null,
				rateCancelDeadline = null,
				rateCancelFee = null,
				rateCurrencyCode = 'USD',
				rateCurrencySymbol = getCurrencySymbol(rateCurrencyCode),
				ratePlanCancelPolicy = null,
				ratePlanName = null,
				renderNightlyRates = [],
				roomRatePlanId = null,
				partnerRateData = null

		if (
			roomRateData.total &&
			roomRateData.total.currencyCode
		) {
			rateCurrencyCode = roomRateData.total.currencyCode
			rateCurrencySymbol = getCurrencySymbol(rateCurrencyCode)
		}

		// Calculated exchange format for daily price symbol and code
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate &&
			activeCurrencyData.currencyCode
		) {
			rateCurrencyCode = activeCurrencyData.currencyCode

			if (activeCurrencyData.currencySymbol) {
				rateCurrencySymbol = activeCurrencyData.currencySymbol
			} else {
				rateCurrencySymbol = getCurrencySymbol(activeCurrencyData.currencyCode)
			}
		}

		// Set rate plan name
		if (
			ratePlanData &&
			ratePlanData.ratePlanName
		) {
			ratePlanName = ratePlanData.ratePlanName
		}

		// Set rate plan cancel fee and deadline
		if (
			roomRateData &&
			roomRateData.rates &&
			_.get(roomRateData.rates, '[0].cancelPolicies') &&
			!_.isEmpty(roomRateData.rates[0].cancelPolicies)
		) {
			const cancellationRules = roomRateData.rates[0].cancelPolicies[0]

			if (
				cancellationRules.deadline &&
				cancellationRules.deadline.absoluteDeadline
			) {
				rateCancelDeadline = moment(new Date(cancellationRules.deadline.absoluteDeadline)).format(dateFormats.roomRateCancellationDeadline)
			}

			if (
				cancellationRules.penaltyDescription &&
				cancellationRules.penaltyDescription.text
			) {
				ratePlanCancelPolicy = cancellationRules.penaltyDescription.text
			}

			if (cancellationRules.amountPercent) {
				if (cancellationRules.amountPercent.amount) {
					rateCancelFee = formatPrice(cancellationRules.amountPercent.amount)
				}

				if (cancellationRules.amountPercent.currencyCode) {
					rateCancelCurrencyCode = formatPrice(cancellationRules.amountPercent.currencyCode)
					rateCancelCurrencySymbol = getCurrencySymbol(rateCancelCurrencyCode)
				}
			}
		}

		// enable front end exchange rate calculations
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate
		) {
			if (displayedPriceFrequency === 'per stay') {
				roomRatePrice = roomRateData.rates[0].total.amountBeforeTax * activeCurrencyData.exchangeRate
			} else {
				roomRatePrice = roomRateData.rates[0].total.amountBeforeTax / totalNights * activeCurrencyData.exchangeRate
			}
		} else if (displayedPriceFrequency === 'per stay') {
			// Set average rate to nightly or total based on env
			roomRatePrice = roomRateData.rates[0].total.amountBeforeTax
		} else {
			roomRatePrice = roomRateData.rates[0].total.amountBeforeTax / totalNights
		}

		// Combine discount line items into a single total
		if (
			roomRateData.discounts &&
			!_.isEmpty(roomRateData.discounts)
		) {
			for (const discountKey in roomRateData.discounts) {
				const currentDiscount = roomRateData.discounts[discountKey]
				roomRateDiscountData.push(currentDiscount.amountBeforeTax)
			}
		}

		// Calculate rate before discount
		if (
			roomRatePrice > 0 &&
			!_.isEmpty(roomRateDiscountData)
		) {
			// Default rate before discount (average nightly rate)
			rateBeforeDiscount = roomRateDiscountData.reduce(addTotals) + roomRatePrice / totalNights

			// Calculate rate by total amount before tax
			if (displayedPriceFrequency === 'per stay') {
				rateBeforeDiscount = roomRateDiscountData.reduce(addTotals) + roomRatePrice

				// Enable front-end FOREX conversion on total amount
				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
					activeCurrencyData &&
					activeCurrencyData.exchangeRate
				) {
					rateBeforeDiscount = roomRateDiscountData.reduce(addTotals) + roomRatePrice * activeCurrencyData.exchangeRate
				}
			} else if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
				activeCurrencyData &&
				activeCurrencyData.exchangeRate
			) {
				// Enable front-end FOREX conversion on average nightly amount
				rateBeforeDiscount = roomRateDiscountData.reduce(addTotals) + roomRatePrice / totalNights * activeCurrencyData.exchangeRate
			}
		}

		if (
			roomRateData &&
			roomRateData.viewExtensions &&
			!_.isEmpty(roomRateData.viewExtensions.nightlyRates)
		) {
			renderNightlyRates = (
				<BkFlowRoomCardNightlyRates
					configData={configData}
					activeCurrencyData={activeCurrencyData}
					roomRateData={roomRateData}
					rateCurrencyCode={rateCurrencyCode}
					rateCurrencySymbol={rateCurrencySymbol}
				/>
			)
		}

		// Render Partners Branding
		if (
			yn(process.env.REACT_APP_COMPONENT_PARTNERS_RATE_BRANDING) &&
			roomRateData &&
			roomRateData.viewExtensions &&
			roomRateData.viewExtensions.ratePlanId
		) {
			roomRatePlanId = roomRateData.viewExtensions.ratePlanId

			if (String(urlData.promoCode) === String(roomRatePlanId)) {
				if (
					availabilityData &&
					_.get(availabilityData, '[0][0].basicPropertyInfo.viewExtensions.partners')
				) {
					const currentPartnersData = availabilityData[0][0].basicPropertyInfo.viewExtensions.partners.filter(function(partner) {
						return partner.ratePlanId === roomRatePlanId
					})

					partnerRateData = currentPartnersData[0]
				}
			}
		}

		return (
			<div
				className="bk-flow-room__price-col"
				id={'bk-flow-room__rate-' + roomGroup + '-' + roomRateData.roomTypeCode + '-' + roomRateData.ratePlanCode}
			>
				<div
					className="bk-flow-room__price-content row start-xs"
					onClick={
						() => toggleActiveRoom(
							availabilityData,
							roomRateData.roomTypeCode,
							roomRateData.ratePlanCode,
							roomGroup,
							activeStep,
							multiRoomData,
							configData,
							urlData,
							enhancementData
						)
					}
					tabIndex={0}
				>
					<div className="bk-flow-room__price-details">
						{ ratePlanName &&
							<p className="bk-flow-room__price-title u-remove-margin">
								{ratePlanName}
							</p>
						}

						<p className="bk-flow-room__price-value">
							{ ratePlanData &&
								rateBeforeDiscount &&
								rateBeforeDiscount > 0 &&
									<span className="u-txt-strike">
										{rateCurrencySymbol}
										{formatPrice(rateBeforeDiscount)}&nbsp;
										{rateCurrencyCode}
									</span>
							}

							<span className="price u-font-bold">
								{ rateCurrencySymbol }
								{ formatPrice(roomRatePrice, 2) }&nbsp;
							</span>

							<span className="price-type u-text-titlecase">
								{ yn(process.env.REACT_APP_COMPONENT_ROOM_CURRENCY_CODES) ? rateCurrencyCode : null}/{hotelLabels && hotelLabels.night ? hotelLabels.night : 'Night' }
							</span>
						</p>
					</div>

					<div className="bk-flow-room__price-arrow">
						<img src={arrowRightLong} alt="Advance Arrow" />
					</div>

					<div className="bk-flow-room__price-info u-popover__toggle">
						<img src={informationIcon} alt="More Information" />
					</div>

					<div className="u-popover">
						<div className="u-popover__content u-remove-margin u-font-medium">
							<div className="u-popover__arrow"></div>
							{ ratePlanName && <p className="u-popover__title u-font-bold">{ratePlanName}</p> }

							{ ratePlanCancelPolicy &&
								<Fragment>
									<h6 className="u-font-bold">
										{ hotelLabels &&
											hotelLabels.cancellationPolicy ?
												hotelLabels.cancellationPolicy
										:
											'Cancellation Policy'
										}
									</h6>

									{ rateCancelDeadline
										&& rateCancelFee ?
										<p className="cancel-deadline">
											{ hotelLabels && hotelLabels.cancel ? hotelLabels.cancellationche + ' ' : 'Cancellation charge of '}
											{ rateCancelCurrencySymbol }{rateCancelFee }{ rateCancelCurrencyCode }{ ' until ' }{ rateCancelDeadline }
										</p>
									: rateCancelDeadline ?
										<p className="cancel-deadline">
											{ hotelLabels && hotelLabels.cancel ? hotelLabels.cancel + ' ' : 'Cancel '} free of charge until { rateCancelDeadline }
										</p>
									:
										null
									}

									{ ratePlanCancelPolicy && <p>{ratePlanCancelPolicy}</p> }
								</Fragment>
							}

							{ yn(process.env.REACT_APP_COMPONENT_PARTNERS_RATE_DETAILS) && partnerRateData && <BkFlowPartnersBenefitsBanner disableLogo={true} /> }

							{ renderNightlyRates }

							<BkFlowRoomCardTaxesFees
								hotelLabels={hotelLabels}
								roomRateData={roomRateData}
								activeCurrencyData={activeCurrencyData}
								rateCurrencyCode={rateCurrencyCode}
								rateCurrencySymbol={rateCurrencySymbol}
							/>

							<p className="u-remove-margin u-font-bold">
								{ hotelLabels && hotelLabels.total ? hotelLabels.total : 'Total'}
							</p>

							<p className="u-remove-margin">
								<span className="u-font-bold">
									{ rateCurrencySymbol }
									{ yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
										activeCurrencyData &&
										activeCurrencyData.exchangeRate ?
										formatPrice(roomRateData.rates[0].total.amountAfterTax * activeCurrencyData.exchangeRate, 2)
									:
										formatPrice(roomRateData.rates[0].total.amountAfterTax, 2)
									}
									&nbsp;
								</span>
								{rateCurrencyCode}
							</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		activeCurrencyData: state.activeCurrencyData,
		activeStep: state.activeStepData.activeStep,
		availabilityData: state.availabilityData.availability,
		configData: state.configData.configuration,
		enhancementData: state.enhancementData,
		multiRoomData: state.multiRoomData,
		urlData: state.availabilityData.urlData,
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomCardCondensedPriceButton)


// WEBPACK FOOTER //
// ./src/components/room/elements/condensed/BkFlowRoomCardCondensedPriceButton.js